import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../../components/grid/headerTemplate/headerTemplate.vue";

export default {
	extends: gridClientBase,
	components: {},

	data: function() {
		return {
			loading: false,
			savePendingRequest: null

			// items: []
		};
	},

	created() {
		this.getData(1);
		var newItem = {
			id: this.indexNewItem,
			name: "",
			description: ""
		};
		this.defaultAddRow = newItem;
		this.sort = [{field: "name", dir: "asc"}];
	},

	/* metodi */
	methods: {
		saveData: function() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = api.postGroupsData(this.createdItems, this.updatedItems, this.deletedItems)
				.then(res => {
					self.createdItems = [];
					self.updatedItems = [];
					self.deletedItems = [];

					self.isInEditMode = false;
					self.getData();
				})
				.catch(err => {
					console.log("KO" + err);
				}).finally(_ => {
					self.savePendingRequest = null;
				});
			}
		},

		getData: function() {
			var self = this;
			this.loading = true;

			this.getGroups(self);
		},

		getGroups: function(self) {
			api.getGroupsData().then(res => {
				self.loading = false;
				self.items = res.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						description: item.description
					};
				});
			});
		},

		switchEditMode: function() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		getNestedValue(fieldName, dataItem) {
			const path = fieldName.split('.');
			let data = dataItem;
			path.forEach((p) => {
				data = data ? data[p] : undefined;
			});
		
			return data;
		}
	},

	/* visualizzazione risultati */
	computed: {
		columns: function() {
			return [
				{
					field: "name",
					title: "nome",
					width: "315",
					minResizableWidth: '150',
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "description",
					title: "descrizione",
					width: "315",
					minResizableWidth: '150',
					cell: "myCellTemplateNotRequired",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "",
					title: "",
					width: "",
					cell: "",
					headerCell: "",
					filterable: false,
					sortable: false
				},
				{
					cell: cellDeleteCommand,
					width: "45",
					minResizableWidth: '45',
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
			];
		}
	}
};
